import { ApiClient } from '@marketplace-web/core-api/api-client-util'

import { GetUserNotificationsArgs } from '../types/args'
import { GetUnreadNotificationsCountResp, GetUserNotificationsResp } from '../types/response'

const api = new ApiClient({
  baseURL: '/web/api/notifications',
  headers: { platform: 'web' },
})

export const getUserNotifications = ({ page, perPage }: GetUserNotificationsArgs) => {
  return api.get<GetUserNotificationsResp>('/notifications', {
    params: {
      page,
      per_page: perPage,
    },
  })
}

export const getUnreadNotifications = () =>
  api.get<GetUnreadNotificationsCountResp>('/notifications/unread_count')
